
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, DollarSign, Clock, Star } from "lucide-react";
import { Link } from "react-router-dom";

const BarStaff = () => {
  const availableShifts = [
    {
      id: 1,
      venue: "Skyline Bar",
      date: "This Friday",
      time: "6:00 PM - 2:00 AM",
      rate: "$25/hr + tips",
      experience: "2+ years"
    },
    {
      id: 2,
      venue: "The Cocktail Club",
      date: "Saturday",
      time: "7:00 PM - 3:00 AM",
      rate: "$30/hr + tips",
      experience: "3+ years"
    }
  ];

  const perks = [
    {
      icon: DollarSign,
      title: "Competitive Pay",
      description: "Earn hourly rates plus tips and bonuses"
    },
    {
      icon: Clock,
      title: "Flexible Schedule",
      description: "Pick up shifts that work for you"
    },
    {
      icon: Star,
      title: "Top Venues",
      description: "Work at the city's best bars and clubs"
    },
    {
      icon: Calendar,
      title: "Regular Work",
      description: "Find consistent opportunities"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Bar Staff Opportunities
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Find flexible bartending shifts at top venues across the city
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {perks.map((perk, index) => (
            <Card key={index} className="p-6 bg-gray-900/50 border-gray-800">
              <perk.icon className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">{perk.title}</h3>
              <p className="text-gray-400">{perk.description}</p>
            </Card>
          ))}
        </div>

        <Card className="bg-gray-900/50 border-gray-800 p-6 mb-8">
          <h2 className="text-2xl font-semibold text-white mb-6">Available Shifts</h2>
          <div className="space-y-4">
            {availableShifts.map((shift) => (
              <Card key={shift.id} className="p-4 bg-gray-800/50 border-gray-700">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="font-semibold text-white">{shift.venue}</h3>
                    <p className="text-gray-400">{shift.date} • {shift.time}</p>
                  </div>
                  <div className="text-right">
                    <Badge className="mb-2">{shift.experience}</Badge>
                    <p className="text-purple-400 font-semibold">{shift.rate}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </Card>

        <div className="text-center">
          <Button asChild size="lg" className="bg-purple-600 hover:bg-purple-700">
            <Link to="/auth">Apply as Bar Staff</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BarStaff;
